import { AfterViewInit, OnDestroy, OnInit } from "@angular/core";
import { AppStore } from "@app/core/store/app.store";
import { environment } from "src/environments/environment";
import { IAppGlobalConfig, IAppSession, IAppUi } from "./app.store.interface";

export class AppStoreModel {
  // ui: IAppUi = {
  //   appTitle: {
  //     full: "Sistema Integrado de Gestión de Operaciones",
  //     mini: "SIGO",
  //   },
  //   drawerMini: false,
  //   isMobile: false,
  //   drawerOpen: false,
  //   drawerMobileOpen: false,
  //   showSideNavRight: true,
  //   appMenu: [],
  // };


  ui: IAppUi = {
    appTitle: { full: 'Sistema Integrado de Gestión de Operaciones', mini: 'SIGO' },
    drawerMini: false,
    isMobile: false,
    drawerOpen: false,
    drawerMobileOpen: false,
    showSideNavRight: true,
    appMenuDashboard: [
      {
        label: 'BONIFICACIÓN',
        link: "/index-bonificacion/",
        // link: "/procedimientos-tupa/mensaje-tupa/tupa/" + btoa("BONIFICACIÓN") + "/" + btoa("https://sgd.pvn.gob.pe/"),
        icon: '../../../../../../assets/img/dashboard/pvn001.png',
        icon_back: '',
        content: 'PVN001 - OTORGAMIENTO DE PERMISOS DE BONIFICACIÓN',
        content_back: 'PVN001 - SUSPENSIÓN NEUMÁTICA Y/O NEUMÁTICOS EXTRA ANCHOS'
      },
      {
        label: 'DERECHO DE VÍA',
        link: "/procedimientos-tupa/nuevo-formulario-tupa/tupa/" + btoa("2"),
        icon: '../../../../../../assets/img/dashboard/pvn002.png',
        icon_back: 'more_horiz',
        content: 'PVN002 - EJECUCIÓN DE OBRAS DE INFRAESTRUCTURA',
        content_back: 'PVN002 - EJECUCIÓN DE OBRAS DE INFRAESTRUCTURA'
      }, {
        label: 'DERECHO DE VÍA',
        link: "/procedimientos-tupa/nuevo-formulario-tupa/tupa/" + btoa("3"),
        icon: '../../../../../../assets/img/dashboard/pvn003.png',
        icon_back: 'more_horiz',
        content: 'PVN003 - INSTALACIÓN DE SEÑALES DE INFORMACIÓN',
        content_back: 'PVN003 - INSTALACIÓN DE SEÑALES DE INFORMACIÓN'
      },
      // {
      //   label: 'VEHÍCULOS Y/O MERCANCÍAS ESPECIALES',
      //   // link: "/procedimientos-tupa/mensaje-tupa/tupa/" + btoa("PVN004 CIRCULACIÓN DE COMBINACIONES CVE") + "/" + btoa("http://autorizacionesespeciales.proviasnac.gob.pe:8080/provias48a60tn/a_login"),
      //   link: "/autorizaciones/formulario-autorizacion-aam/form-autorizacion-aas",
      //   icon: '../../../../../../assets/img/dashboard/pvn004.png',
      //   icon_back: 'more_horiz',
      //   content: 'PVN004 - CIRCULACIÓN DE COMBINACIONES VEHICULARES ESPECIALES-CVE',
      //   content_back: 'PVN004 - CIRCULACIÓN DE COMBINACIONES VEHICULARES ESPECIALES-CVE'
      // },
      {
        label: 'VEHÍCULOS Y/O MERCANCÍAS ESPECIALES',
        link: "/procedimientos-tupa/mensaje-tupa/tupa/" + btoa("PVN004 CIRCULACIÓN DE COMBINACIONES VEHICULARES ESPECIALES-CVE") + "/" + btoa("http://autorizacionesespeciales.proviasnac.gob.pe:8080/provias48a60tn/a_login"),
        icon: '../../../../../../assets/img/dashboard/pvn004.png',
        icon_back: 'more_horiz',
        content: 'PVN004 - CIRCULACIÓN DE COMBINACIONES VEHICULARES ESPECIALES-CVE',
        content_back: 'PVN004 - CIRCULACIÓN DE COMBINACIONES VEHICULARES ESPECIALES-CVE'
      },
      {
        label: 'VEHÍCULOS Y/O MERCANCÍAS ESPECIALES',
        link: "/procedimientos-tupa/mensaje-tupa/tupa/" + btoa("PVN005 TRANSPORTE DE MERCANCÍAS ESPECIALES EN VEHÍCULOS ESPECIALES O NO ESPECIALES PESO BRUTO VEHICULAR MAYOR A 48 TN HASTA 60 TN Y DESPLAZAMIENTO EN CONVOY") + "/" + btoa("https://sgd.pvn.gob.pe/"),
        icon: '../../../../../../assets/img/dashboard/pvn005.png',
        icon_back: '',
        content: 'PVN005 - TRANSPORTE DE MERCANCÍAS ESPECIALES EN VEHÍCULOS ESPECIALES O NO ESPECIALES',
        content_back: 'PVN005 - PESO BRUTO VEHICULAR MAYOR A 48 TN HASTA 60 TN Y DESPLAZAMIENTO EN CONVOY'
      }, {
        label: 'VEHÍCULOS Y/O MERCANCÍAS ESPECIALES',
        link: "/procedimientos-tupa/mensaje-tupa/tupa/" + btoa("PVN006 TRANSPORTE DE MERCANCÍAS ESPECIALES EN VEHÍCULOS ESPECIALES O NO ESPECIALES ESPECIALES-CVE PESO BRUTO VEHICULAR MAYOR A 60 TN Y DESPLAZAMIENTO EN CONVOY") + "/" + btoa("https://sgd.pvn.gob.pe/"),
        icon: '../../../../../../assets/img/dashboard/pvn006.png',
        icon_back: 'more_horiz',
        content: 'PVN006 - TRANSPORTE DE MERCANCÍAS ESPECIALES EN VEHÍCULOS ESPECIALES O NO ESPECIALES ESPECIALES-CVE',
        content_back: 'PVN006 - PESO BRUTO VEHICULAR MAYOR A 60 TN Y DESPLAZAMIENTO EN CONVOY'
      }, {
        label: 'VEHÍCULOS Y/O MERCANCÍAS ESPECIALES',
        link: "/procedimientos-tupa/mensaje-tupa/tupa/" + btoa("PVN007 TRANSPORTE DE MERCANCÍAS ESPECIALES QUE EXCEDEN DIMENSIONES MÁXIMAS PERMITIDAS Y DESPLAZAMIENTO EN CONVOY") + "/" + btoa("https://sgd.pvn.gob.pe/"),
        icon: '../../../../../../assets/img/dashboard/pvn007.png',
        icon_back: 'more_horiz',
        content: 'PVN007 - TRANSPORTE DE MERCANCÍAS ESPECIALES QUE EXCEDEN',
        content_back: 'PVN007 - DIMENSIONES MÁXIMAS PERMITIDAS Y DESPLAZAMIENTO EN CONVOY'
      }, {
        label: 'VEHÍCULOS Y/O MERCANCÍAS ESPECIALES',
        link: "/procedimientos-tupa/mensaje-tupa/tupa/" + btoa("PVN008 CIRCULACIÓN DE LOS VEHÍCULOS ESPECIALES DE LAS CATEGORÍAS N Y O") + "/" + btoa("https://sgd.pvn.gob.pe/"),
        icon: '../../../../../../assets/img/dashboard/pvn008.png',
        icon_back: '',
        content: 'PVN008 - CIRCULACIÓN DE LOS VEHÍCULOS ESPECIALES DE LAS CATEGORÍAS N Y O',
        content_back: 'PVN008 - CIRCULACIÓN DE LOS VEHÍCULOS ESPECIALES DE LAS CATEGORÍAS N Y O'
      },
      {
        label: 'TARIFA DIFERENCIA',
        link: "/procedimientos-tupa/nuevo-formulario-tupa/tupa/" + btoa("9"),
        icon: '../../../../../../assets/img/dashboard/pvn009.png',
        icon_back: '',
        content: 'PVN009 - PERSONA NATURAL CON MÁXIMO 3 VEHÍCULOS LIVIANOS Y/O PESADOS USO PARTICULAR',
        content_back: 'PVN009 - PERSONA NATURAL CON MÁXIMO 3 VEHÍCULOS LIVIANOS Y/O PESADOS USO PARTICULAR'
      }, {
        label: 'TARIFA DIFERENCIADA',
        link: "/procedimientos-tupa/nuevo-formulario-tupa/tupa/" + btoa("10"),
        icon: '../../../../../../assets/img/dashboard/pvn010.png',
        icon_back: 'more_horiz',
        content: 'PVN010 - RENOVACIÓN PERSONA NATURAL MÁXIMO 3 VEHÍCULOS LIVIANOS Y/O PESADOS USO PARTICULAR',
        content_back: 'PVN010 - RENOVACIÓN PERSONA NATURAL MÁXIMO 3 VEHÍCULOS LIVIANOS Y/O PESADOS USO PARTICULAR'
      },
      {
        label: 'TARIFA DIFERENCIADA',
        link: "/procedimientos-tupa/nuevo-formulario-tupa/tupa/" + btoa("11"),
        icon: '../../../../../../assets/img/dashboard/pvn011.png',
        icon_back: '',
        content: 'PVN011 - GOBIERNOS LOCALES Y REGIONALES VEHÍCULOS DESTINADOS AL SERVICIO PÚBLICO O SEGURIDAD CIUDADANA',
        content_back: 'PVN011 - GOBIERNOS LOCALES Y REGIONALES VEHÍCULOS DESTINADOS AL SERVICIO PÚBLICO O SEGURIDAD CIUDADANA'
      }, {
        label: 'TARIFA DIFERENCIADA',
        link: "/procedimientos-tupa/nuevo-formulario-tupa/tupa/" + btoa("12"),
        icon: '../../../../../../assets/img/dashboard/pvn012.png',
        icon_back: '',
        content: 'PVN012 - TRANSPORTE DE MERCANCIAS EN RUTAS NO MAYORES A 80KM',
        content_back: 'PVN012 - TRANSPORTE DE MERCANCIAS EN RUTAS NO MAYORES A 80KM'
      },
      {
        label: 'TARIFA DIFERENCIADA',
        link: "/procedimientos-tupa/nuevo-formulario-tupa/tupa/" + btoa("13"),
        icon: '../../../../../../assets/img/dashboard/pvn013.png',
        icon_back: '',
        content: 'PVN013 - TRANSPORTE PUBLICO DE PASAJEROS EN RUTAS NO MAYORES A 80KM',
        content_back: 'PVN013 - TRANSPORTE PUBLICO DE PASAJEROS EN RUTAS NO MAYORES A 80KM'
      },
      {
        label: 'TARIFA DIFERENCIADA',
        link: "/procedimientos-tupa/nuevo-formulario-tupa/tupa/" + btoa("14"),
        icon: '../../../../../../assets/img/dashboard/pvn014.png',
        icon_back: '',
        content: 'PVN014 - RENOVACION PARA TRANSPORTE PUBLICO DE PASAJEROS Y TRANSPORTE DE MERCANCIAS EN RUTAS NO MAYORES A 80KM',
        content_back: 'PVN014 - RENOVACION PARA TRANSPORTE PUBLICO DE PASAJEROS Y TRANSPORTE DE MERCANCIAS EN RUTAS NO MAYORES A 80KM'
      },
    ],
    appMenu: [
      {
        label: 'Home',
        icon: 'home',
        link: '/',
        onSelected: function () {
        }
      },
      {
        label: 'BONIFICACIÓN',
        icon: 'assignment',
        items: [
          {
            label: 'CERTIFICADO DE BONIFICACIÓN',
            link: "/permiso-bonificacion/certificado-solicitud-bonif",
            icon: 'more_horiz'
          },
          {
            label: 'SOLICITUD DE BONIFICACIÓN',
            link: "/permiso-bonificacion/nueva-solicitud-bonif",
            icon: 'more_horiz'
          }
        ]
      },
      // {
      //   label: 'DERECHO DE VÍA',
      //   icon: 'assignment',
      //   items: [
      //     {
      //       label: 'PVN002 EJECUCIÓN DE OBRAS DE INFRAESTRUCTURA',
      //       link: "/procedimientos-tupa/nuevo-formulario-tupa/tupa/" + btoa("2"),
      //       icon: 'more_horiz'
      //     },
      //     {
      //       label: 'PVN003 INSTALACIÓN DE SEÑALES DE INFORMACIÓN',
      //       link: "/procedimientos-tupa/nuevo-formulario-tupa/tupa/" + btoa("3"),
      //       icon: 'more_horiz'
      //     }
      //   ]
      // },
      {
        label: 'VEHÍCULOS Y/OE MERCANCÍAS ESPECIALES',
        icon: 'contact_mail',
        items: [
          // {
          //   label: 'PVN004 CIRCULACIÓN DE COMBINACIONES CVE',
          //   link: "/procedimientos-tupa/mensaje-tupa/tupa/" + btoa("PVN004 CIRCULACIÓN DE COMBINACIONES CVE") + "/" + btoa("http://autorizacionesespeciales.proviasnac.gob.pe:8080/provias48a60tn/a_login"),
          //   icon: 'timeline',
          //   onSelected: function () {
          //   }
          // },
          {
            label: 'PVN004 - CIRCULACIÓN DE COMBINACIONES VEHICULARES ESPECIALES-CVE',
            link: "/procedimientos-tupa/mensaje-tupa/tupa/" + btoa("PVN004 CIRCULACIÓN DE COMBINACIONES VEHICULARES ESPECIALES-CVE") + "/" + btoa("http://autorizacionesespeciales.proviasnac.gob.pe:8080/provias48a60tn/a_login"),
            icon: 'timeline',
            onSelected: function () {
            }
          },
          {
            label: 'PVN005 - TRANSPORTE DE MERCANCÍAS ESPECIALES EN VEHÍCULOS ESPECIALES O NO ESPECIALES',
            link: "/procedimientos-tupa/mensaje-tupa/tupa/" + btoa("PVN005 TRANSPORTE DE MERCANCÍAS ESPECIALES EN VEHÍCULOS ESPECIALES O NO ESPECIALES PESO BRUTO VEHICULAR MAYOR A 48 TN HASTA 60 TN Y DESPLAZAMIENTO EN CONVOY") + "/" + btoa("https://sgd.pvn.gob.pe/"),
            icon: 'timeline',
            onSelected: function () {
            }
          },
          {
            label: 'PVN006 - TRANSPORTE DE MERCANCÍAS ESPECIALES EN VEHÍCULOS ESPECIALES O NO ESPECIALES ESPECIALES-CVE',
            link: "/procedimientos-tupa/mensaje-tupa/tupa/" + btoa("PVN006 TRANSPORTE DE MERCANCÍAS ESPECIALES EN VEHÍCULOS ESPECIALES O NO ESPECIALES ESPECIALES-CVE PESO BRUTO VEHICULAR MAYOR A 60 TN Y DESPLAZAMIENTO EN CONVOY") + "/" + btoa("https://sgd.pvn.gob.pe/"),
            icon: 'timeline',
            onSelected: function () {
            }
          },
          {
            label: 'PVN007 - TRANSPORTE DE MERCANCÍAS ESPECIALES QUE EXCEDEN',
            link: "/procedimientos-tupa/mensaje-tupa/tupa/" + btoa("PVN007 TRANSPORTE DE MERCANCÍAS ESPECIALES QUE EXCEDEN DIMENSIONES MÁXIMAS PERMITIDAS Y DESPLAZAMIENTO EN CONVOY") + "/" + btoa("https://sgd.pvn.gob.pe/"),
            icon: 'timeline',
            onSelected: function () {
            }
          },
          {
            label: 'PVN008 - CIRCULACIÓN DE LOS VEHÍCULOS ESPECIALES DE LAS CATEGORÍAS N Y O',
            link: "/procedimientos-tupa/mensaje-tupa/tupa/" + btoa("PVN008 CIRCULACIÓN DE LOS VEHÍCULOS ESPECIALES DE LAS CATEGORÍAS N Y O") + "/" + btoa("https://sgd.pvn.gob.pe/"),
            icon: 'timeline',
            onSelected: function () {
            }
          },
        ]
      },
      // {
      //   label: 'TARIFA DIFERENCIA',
      //   icon: 'assignment',
      //   items: [
      //     {
      //       label: 'PVN009 PERSONA NATURAL CON MÁXIMO 3 VEHICULOS LIVIANOS',
      //       link: "/procedimientos-tupa/nuevo-formulario-tupa/tupa/" + btoa("9"),
      //       icon: 'more_horiz'
      //     },
      //     {
      //       label: 'PVN010 PERSONA NATURAL CON MÁXIMO 3 VEHICULOS LIVIANOS',
      //       link: "/procedimientos-tupa/nuevo-formulario-tupa/tupa/" + btoa("10"),
      //       icon: 'more_horiz'
      //     },
      //     {
      //       label: 'PVN011 PERSONA NATURAL CON MÁXIMO 3 VEHICULOS LIVIANOS',
      //       link: "/procedimientos-tupa/nuevo-formulario-tupa/tupa/" + btoa("11"),
      //       icon: 'more_horiz'
      //     },
      //     {
      //       label: 'PVN012 PERSONA NATURAL CON MÁXIMO 3 VEHICULOS LIVIANOS',
      //       link: "/procedimientos-tupa/nuevo-formulario-tupa/tupa/" + btoa("12"),
      //       icon: 'more_horiz'
      //     },
      //     {
      //       label: 'PVN013 PERSONA NATURAL CON MÁXIMO 3 VEHICULOS LIVIANOS',
      //       link: "/procedimientos-tupa/nuevo-formulario-tupa/tupa/" + btoa("13"),
      //       icon: 'more_horiz'
      //     },
      //     {
      //       label: 'PVN014 PERSONA NATURAL CON MÁXIMO 3 VEHICULOS LIVIANOS',
      //       link: "/procedimientos-tupa/nuevo-formulario-tupa/tupa/" + btoa("14"),
      //       icon: 'more_horiz'
      //     },
      //   ]
      // },
      // {
      //   label: 'Componente Vehicular',
      //   icon: 'how_to_vote',
      //   items: [
      //     {
      //       label: 'Gestión de Componente Vehicular',
      //       link: '/componente-vehicular/listado-componente-vehicular',
      //       icon: 'more_horiz'
      //     }
      //   ]
      // },
      // {
      //   label: 'Certificado de Bonificación',
      //   icon: 'assignment',
      //   items: [
      //     {
      //       label: 'Gestión de Certificados',
      //       link: '/bonificaciones/form-certificado-bonif',
      //       icon: 'more_horiz'
      //     },
      //     {
      //       label: 'Gestión personal de planta',
      //       link: '/bonificaciones/gest-certificado-bonif',
      //       icon: 'more_horiz'
      //     }
      //   ]
      // },
      /*
      {
        label: 'Casilla Electrónica',
        icon: 'how_to_vote',
        items: [
          {
            label: 'Gestión de Casillas',
            link: '/asociar-casilla/listado-casilla',
            icon: 'more_horiz'
          }
        ]
      },
      */
      // {
      //   label: 'Solicitud de Bonificación',
      //   icon: 'local_shipping',
      //   items: [
      //     {
      //       label: 'Gestión de Solicitudes',
      //       link: '/permiso-bonificacion/listado-solicitudes-bonif',
      //       icon: 'more_horiz'
      //     }
      //   ]
      // },
      // {
      //   label: 'Bandeja SIGO',
      //   icon: 'source',
      //   items: [
      //     {
      //       label: 'Bandeja General',
      //       link: '/bandeja/bandeja-general',
      //       icon: 'source'
      //     }
      //   ]
      // },
      /*{
        label: 'Crear Usuario Secundario',
        icon: 'local_shipping',
        items: [
          {
            label: 'Usuario Secundario',
            link: '/usuarios/usuario',
            icon: 'more_horiz'
          }
        ]
      },*/
      // {
      //   label: 'Bandeja Documentos',
      //   icon: 'source',
      //   items: [
      //     {
      //       label: 'Firmados',
      //       link: '/bandeja/bandeja-firma',
      //       icon: 'source'
      //     },
      //     {
      //       label: 'Notificados',
      //       link: '/bandeja/bandeja-notificacion',
      //       icon: 'source'
      //     }
      //   ]
      // },
      // {
      //   label: 'Peaje',
      //   icon: 'airport_shuttle',
      //   items: [
      //     {
      //       label: 'Gestión de Oficina Zonal',
      //       link: '/peaje/gestionar-ofi-zonal',
      //       icon: 'emoji_transportation',
      //       onSelected: function () {
      //         console.log('oficina zonal');
      //       }
      //     },
      //     {
      //       label: 'Gestión de Peaje',
      //       link: '/peaje/gestionar-peaje',
      //       icon: 'commute',
      //       onSelected: function () {
      //         console.log('peaje');
      //       }
      //     },
      //     {
      //       label: 'Gestión de Sentido de Vía',
      //       link: '/peaje/gestionar-sen-via',
      //       icon: 'add_road',
      //       onSelected: function () {
      //         console.log('peaje');
      //       }
      //     },
      //     {
      //       label: 'Gestión de Turno',
      //       link: '/peaje/gestionar-turno',
      //       icon: 'assignment_turned_in',
      //       onSelected: function () {
      //         console.log('peaje');
      //       }
      //     },
      //     {
      //       label: 'Gestión de Tipo Entidad Exonerada',
      //       link: '/peaje/gestionar-tip-ent-exo',
      //       icon: 'apartment',
      //       onSelected: function () {
      //         console.log('peaje');
      //       }
      //     },
      //     {
      //       label: 'Gestión de Motivo Anulación Comprobante',
      //       link: '/peaje/gestionar-mot-anu-com',
      //       icon: 'backspace',
      //       onSelected: function () {
      //         console.log('peaje');
      //       }
      //     },
      //     {
      //       label: 'Gestión de Concepto Interno',
      //       link: '/peaje/gestionar-con-int',
      //       icon: 'select_all',
      //       onSelected: function () {
      //         console.log('peaje');
      //       }
      //     },
      //     // {
      //     //   label: 'Gestión de Ruta de Peajes',
      //     //   link: '/peaje/gestionar-ruta',
      //     //   icon: 'alt_route',
      //     //   onSelected: function () {
      //     //     console.log('peaje');
      //     //   }
      //     // },
      //     // {
      //     //   label: 'Gestión de Via',
      //     //   link: '/peaje/gestionar-via',
      //     //   icon: 'offline_pin',
      //     //   onSelected: function () {
      //     //     console.log('via');
      //     //   }
      //     // }
      //     // {
      //     //   label: 'Solicitar Autorización ABS',
      //     //   link: '/autorizaciones/formulario-autorizacion-aam/form-autorizacion-abs',
      //     //   icon: 'offline_pin',
      //     //   onSelected: function () {
      //     //     console.log('autorizacion AAS');
      //     //   }
      //     // }
      //   ]
      // },
      // {
      //   label: 'Horario',
      //   icon: 'airport_shuttle',
      //   items: [
      //     {
      //       label: 'Programación Horarios',
      //       link: '/horarios/programacion',
      //       icon: 'emoji_transportation',
      //       onSelected: function () {
      //         console.log('programación horarios');
      //       }
      //     },
      //   ]
      // },
      // {
      //   label: 'Peaje Caja',
      //   icon: 'airport_shuttle',
      //   items: [
      //     {
      //       label: 'Lista Caja',
      //       link: '/peaje-caja/lista-caja',
      //       icon: 'emoji_transportation',
      //       onSelected: function () {
      //         console.log('programación horarios');
      //       }
      //     },
      //     {
      //       label: 'Lista Boletos',
      //       link: '/peaje-caja/formulario-boletos',
      //       icon: 'emoji_transportation',
      //       onSelected: function () {
      //         console.log('boletos');
      //       }
      //     },
      //     {
      //       label: 'Lista Boletos Asignados',
      //       link: '/peaje-caja/frm-boletos-asignados',
      //       icon: 'emoji_transportation',
      //       onSelected: function () {
      //         console.log('frm-boletos-asignados');
      //       }
      //     },
      //     /*{
      //       label: 'Lista Boletos Pre Asignados',
      //       link: '/peaje-caja/frm-boletos-pre-asignados',
      //       icon: 'emoji_transportation',
      //       onSelected: function () {
      //         console.log('frm-boletos-pre-asignados');
      //       }
      //     },*/
      //     /*{
      //       label: 'Lista Liquidaciones',
      //       link: '/horarios/programacion',
      //       icon: 'emoji_transportation',
      //       onSelected: function () {
      //         console.log('programación horarios');
      //       }
      //     },*/
      //   ]
      // },
    ],
    appMenu1: [
      {
        label: 'Home',
        icon: 'home',
        link: '/',
        onSelected: function () {
          console.log('Item 3');
        }
      },
      // {
      //   label: 'Demo',
      //   icon: 'important_devices',
      //   items: [
      //     {
      //       label: 'Tablas',
      //       link: '/demo/tablas',
      //       icon: 'short_text',
      //     },
      //     {
      //       label: 'Botones',
      //       link: '/demo/botones',
      //       icon: 'short_text',
      //     },
      //     {
      //       label: 'Crud',
      //       link: '/demo/crud',
      //       icon: 'short_text',
      //     },
      //     {
      //       label: 'Tree picker',
      //       link: '/demo/tree-picker',
      //       icon: 'short_text',
      //     },
      //     {
      //       label: 'Forms',
      //       link: '/demo/forms',
      //       icon: 'short_text',
      //     },
      //   ]
      // },
      {
        label: 'Autorizaciones',
        icon: 'contact_mail',
        items: [
          {
            label: 'Gestión de Autorizaciones Generadas',
            link: '',
            icon: 'timeline',
            onSelected: function () {
              console.log('autorizacion AAS');
            }
          },
          // {
          //   label: 'Solicitar Autorización AAS',
          //   link: '/autorizaciones/formulario-autorizacion-aam/form-autorizacion-aas',
          //   icon: 'offline_pin',
          //   onSelected: function () {
          //     console.log('autorizacion AAS');
          //   }
          // },
          // {
          //   label: 'Solicitar Autorización ABS',
          //   link: '/autorizaciones/formulario-autorizacion-aam/form-autorizacion-abs',
          //   icon: 'offline_pin',
          //   onSelected: function () {
          //     console.log('autorizacion AAS');
          //   }
          // }
        ]
      },
      {
        label: 'Componente Vehicular',
        icon: 'how_to_vote',
        items: [
          {
            label: 'Gestión de Componente Vehicular',
            link: '/componente-vehicular/listado-componente-vehicular',
            icon: 'more_horiz'
          }
        ]
      },
      {
        label: 'Certificado de Bonificación',
        icon: 'assignment',
        items: [
          {
            label: 'Gestión de Certificados',
            link: '/bonificaciones/form-certificado-bonif',
            icon: 'more_horiz'
          },
          {
            label: 'Gestión personal de planta',
            link: '/bonificaciones/gest-certificado-bonif',
            icon: 'more_horiz'
          }
        ]
      },
      /*
      {
        label: 'Casilla Electrónica',
        icon: 'how_to_vote',
        items: [
          {
            label: 'Gestión de Casillas',
            link: '/asociar-casilla/listado-casilla',
            icon: 'more_horiz'
          }
        ]
      },
      */
      {
        label: 'Solicitud de Bonificación',
        icon: 'local_shipping',
        items: [
          {
            label: 'Gestión de Solicitudes',
            link: '/permiso-bonificacion/listado-solicitudes-bonif',
            icon: 'more_horiz'
          }
        ]
      },
      /*{
        label: 'Crear Usuario Secundario',
        icon: 'local_shipping',
        items: [
          {
            label: 'Usuario Secundario',
            link: '/usuarios/usuario',
            icon: 'more_horiz'
          }
        ]
      }, */
    ],
    appMenu2: [
      {
        label: 'Home',
        icon: 'home',
        link: '/',
        onSelected: function () {
          console.log('Item 3');
        }
      },
      {
        label: 'Bandeja SIGO',
        icon: 'source',
        items: [
          {
            label: 'Bandeja General',
            link: '/bandeja/bandeja-general',
            icon: 'source'
          }
        ]
      },
      {
        label: 'Bandeja Documentos',
        icon: 'source',
        items: [
          {
            label: 'Firmados',
            link: '/bandeja/bandeja-firma',
            icon: 'source'
          },
          {
            label: 'Notificados',
            link: '/bandeja/bandeja-notificacion',
            icon: 'source'
          }
        ]
      },
      {
        label: 'Peaje',
        icon: 'airport_shuttle',
        items: [
          {
            label: 'Gestión de Oficina Zonal',
            link: '/peaje/gestionar-ofi-zonal',
            icon: 'emoji_transportation',
            onSelected: function () {
              console.log('oficina zonal');
            }
          },
          {
            label: 'Gestión de Peaje',
            link: '/peaje/gestionar-peaje',
            icon: 'commute',
            onSelected: function () {
            }
          },
          {
            label: 'Gestión de Sentido de Vía',
            link: '/peaje/gestionar-sen-via',
            icon: 'add_road',
            onSelected: function () {
            }
          },
          {
            label: 'Gestión de Turno',
            link: '/peaje/gestionar-turno',
            icon: 'assignment_turned_in',
            onSelected: function () {
              console.log('peaje');
            }
          },
          {
            label: 'Gestión de Tipo Entidad Exonerada',
            link: '/peaje/gestionar-tip-ent-exo',
            icon: 'apartment',
            onSelected: function () {
              console.log('peaje');
            }
          },
          {
            label: 'Gestión de Motivo Anulación Comprobante',
            link: '/peaje/gestionar-mot-anu-com',
            icon: 'backspace',
            onSelected: function () {
              console.log('peaje');
            }
          },
          {
            label: 'Gestión de Concepto Interno',
            link: '/peaje/gestionar-con-int',
            icon: 'select_all',
            onSelected: function () {
              console.log('peaje');
            }
          },
          // {
          //   label: 'Gestión de Ruta de Peajes',
          //   link: '/peaje/gestionar-ruta',
          //   icon: 'alt_route',
          //   onSelected: function () {
          //     console.log('peaje');
          //   }
          // },
          // {
          //   label: 'Gestión de Via',
          //   link: '/peaje/gestionar-via',
          //   icon: 'offline_pin',
          //   onSelected: function () {
          //     console.log('via');
          //   }
          // }
          // {
          //   label: 'Solicitar Autorización ABS',
          //   link: '/autorizaciones/formulario-autorizacion-aam/form-autorizacion-abs',
          //   icon: 'offline_pin',
          //   onSelected: function () {
          //     console.log('autorizacion AAS');
          //   }
          // }
        ]
      },
      {
        label: 'Horario',
        icon: 'airport_shuttle',
        items: [
          {
            label: 'Programación Horarios',
            link: '/horarios/programacion',
            icon: 'emoji_transportation',
            onSelected: function () {
              console.log('programación horarios');
            }
          },
        ]
      },
      {
        label: 'Peaje Caja',
        icon: 'airport_shuttle',
        items: [
          {
            label: 'Lista Caja',
            link: '/peaje-caja/lista-caja',
            icon: 'emoji_transportation',
            onSelected: function () {
              console.log('programación horarios');
            }
          },
          {
            label: 'Lista Boletos',
            link: '/peaje-caja/formulario-boletos',
            icon: 'emoji_transportation',
            onSelected: function () {
              console.log('boletos');
            }
          },
          {
            label: 'Lista Boletos Asignados',
            link: '/peaje-caja/frm-boletos-asignados',
            icon: 'emoji_transportation',
            onSelected: function () {
              console.log('frm-boletos-asignados');
            }
          },
          {
            label: 'Lista Boletos Pre Asignados',
            link: '/peaje-caja/frm-boletos-pre-asignados',
            icon: 'emoji_transportation',
            onSelected: function () {
              console.log('frm-boletos-pre-asignados');
            }
          },
          /*{
            label: 'Lista Liquidaciones',
            link: '/horarios/programacion',
            icon: 'emoji_transportation',
            onSelected: function () {
              console.log('programación horarios');
            }
          },*/
        ]
      },
    ]
  };

  session: IAppSession = {
    isLoading: false,
    isLoggedIn: false,
    user: null,
    token: null,
    returnUrl: null,
    loginError: false,
    fromStorage: false,
    sessionExpired: false,
    displayUser: null,
  };

  globalConfig: IAppGlobalConfig = {
    isLoading: false,
    configuration: null,
    error: false,
  };
}

export abstract class BaseLoggedComponent implements OnInit, OnDestroy {
  constructor(protected appStore: AppStore) { }

  ngOnInit() {
    this.appStore.sessionAction.loginCompletar();
  }
  ngOnDestroy() { }
}
export abstract class BaseLoggedComponentTupa implements OnInit, OnDestroy, AfterViewInit {
  constructor(protected appStore: AppStore) { }

  ngOnInit() {
    this.appStore.sessionAction.loginCompletar();
  }
  ngOnDestroy() { }
  ngAfterViewInit() { }
}

export enum TipoPerfilSTS {
  Administrador = environment.tipoPerfilSTS.Administrador,
  Transportista = environment.tipoPerfilSTS.Transportista,
  Certificadora = environment.tipoPerfilSTS.Certificadora,
  JefeOperaciones = environment.tipoPerfilSTS.JefeOperaciones,
  EspecialistaOperaciones = environment.tipoPerfilSTS.EspecialistaOperaciones,
  NotificadorOperaciones = environment.tipoPerfilSTS.NotificadorOperaciones,
  IngenieroOperaciones = environment.tipoPerfilSTS.IngenieroOperaciones,
  ApoyoJefeOperaciones = environment.tipoPerfilSTS.ApoyoJefeOperaciones,
  Abogado = environment.tipoPerfilSTS.Abogado,
}

export enum TipoPerfilSIGO {
  Transportista = 1158,
  PersonaNatural = 1168,
  Certificadora = 2,
  AdminOperaciones = 3,
  EspecialistaOperaciones = 1191,
  Abogado = 5,
}
